import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { LoaderIcon, PlayIcon, PauseIcon } from 'wix-rich-content-ui-components';
import { s as styles } from '../audio.rtlignore-5bf38280.js';
import { AUDIO_BI_VALUES, AUDIO_ACTION_NAMES } from '../consts.js';
import { AUDIO_TYPE } from 'ricos-content';
import '../style-inject.es-e7b07dd7.js';
import 'ricos-types';

const AudioActionIcons = ({
  isPlaying,
  handlePause,
  handlePlay,
  disabled,
  isLoading,
  helpers
}) => {
  const { tabIndex } = useContext(RicosContext);
  const onClick = () => {
    var _a;
    const ACTION_BI_VALUE = isPlaying ? AUDIO_BI_VALUES.PAUSE : AUDIO_BI_VALUES.PLAY;
    (_a = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a.call(helpers, AUDIO_TYPE, AUDIO_ACTION_NAMES.playAudio, ACTION_BI_VALUE);
    isPlaying ? handlePause() : handlePlay();
  };
  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      onClick();
    }
  };
  const ComponentIcon = disabled || !isPlaying ? PlayIcon : PauseIcon;
  const ariaLabel = isPlaying ? "pause" : "play";
  return isLoading ? /* @__PURE__ */ React.createElement(LoaderIcon, { className: styles.audio_loader_icon }) : /* @__PURE__ */ React.createElement(
    "button",
    {
      className: styles.audio_icon_button,
      onClick,
      onKeyPress,
      "aria-label": ariaLabel,
      tabIndex
    },
    /* @__PURE__ */ React.createElement(ComponentIcon, null)
  );
};

export { AudioActionIcons as default };
//# sourceMappingURL=AudioActionIcons.js.map
